import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Loader2 } from "lucide-react";
import { GovOverview } from "@/components/governance/GovOverview";
import { RegisterTab } from "@/components/governance/RegisterTab";
import { DocumentsTab } from "@/components/governance/DocumentsTab";
import { DpiaTab } from "@/components/governance/DpiaTab";
import { AuditTab } from "@/components/governance/AuditTab";

const TABS = [
  ["overview", "Overview"], ["activities", "Processing"], ["subprocessors", "Subprocessors"],
  ["documents", "Documents"], ["dpia", "DPIA"], ["evidence", "Evidence & Gaps"], ["audit", "Audit Log"],
];

export default function Governance() {
  const [meta, setMeta] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => { api.get("/governance/meta").then((r) => setMeta(r.data)).catch(() => setFailed(true)); }, []);
  if (failed)
    return <p className="mt-10 text-center text-sm text-red-700" data-testid="governance-load-error">Could not load the Governance Centre. Please refresh.</p>;
  if (!meta)
    return <div className="flex h-64 items-center justify-center"><Loader2 className="h-7 w-7 animate-spin text-accent" /></div>;

  const body = (k) => {
    if (k === "overview") return <GovOverview meta={meta} />;
    if (k === "documents") return <DocumentsTab meta={meta} />;
    if (k === "dpia") return <DpiaTab meta={meta} />;
    if (k === "audit") return <AuditTab />;
    return <RegisterTab kind={k} meta={meta} />;
  };

  return (
    <div className="space-y-6" data-testid="governance-page">
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">Castlewood Software Ltd</p>
        <h1 className="mt-1 font-heading text-3xl font-extrabold tracking-tight text-slate-900">Governance Centre</h1>
        <p className="mt-1 text-sm text-slate-500">Data protection, security and document governance for RetroTrack (UK GDPR / DPA 2018 / PECR).</p>
      </div>
      <Tabs defaultValue="overview">
        <TabsList className="h-auto flex-wrap justify-start">
          {TABS.map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`gov-tab-${k}`}>{l}</TabsTrigger>)}
        </TabsList>
        {TABS.map(([k]) => <TabsContent key={k} value={k} className="mt-5">{body(k)}</TabsContent>)}
      </Tabs>
    </div>
  );
}
